module.exports = __webpack_public_path__ + "img/landing-aubert.2d4d6145.png";